module.exports = __webpack_public_path__ + "img/Shawn.e1a4e49c.jpg";